import { useEffect, useState } from "react";
import { Card, SectionHeader } from "../components/UI";
import { apiFetch } from "../lib/api";
import { renderMarkdownToHtml } from "../lib/content";

const endpointMap = {
  privacy: "/legal/privacy-policy",
  terms: "/legal/terms",
  refund: "/legal/refund-policy",
  returnpolicy: "/legal/return-policy",
  shipping: "/legal/shipping-policy"
} as const;

const titleMap = {
  privacy: "Privacy Policy",
  terms: "Terms & Conditions",
  refund: "Refund Policy",
  returnpolicy: "Return Policy",
  shipping: "Shipping Policy"
} as const;

export function LegalPage({ type }: { type: keyof typeof endpointMap }) {
  const [markdown, setMarkdown] = useState("");
  const html = renderMarkdownToHtml(markdown);

  useEffect(() => {
    let cancelled = false;
    apiFetch<{ markdown?: string }>(endpointMap[type])
      .then((data) => {
        if (!cancelled) setMarkdown(data.markdown || "");
      })
      .catch(() => {
        if (!cancelled) setMarkdown("");
      });
    return () => {
      cancelled = true;
    };
  }, [type]);

  return (
    <section>
      <SectionHeader title={titleMap[type]} />
      <Card style={{ padding: "var(--space-xl)", maxWidth: 800 }}>
        <div className="legal-content">
          {html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : <div className="text-muted text-sm">Loading...</div>}
        </div>
      </Card>
    </section>
  );
}
